import styles from "./HomePage.module.scss";

export function HomePage() {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>IDMe Web SDK</h1>
        <p className={styles.subtitle}>Identity Verification Platform</p>
        <div className={styles.links}>
          <a href="/testing" className={`${styles.link} ${styles.linkPrimary}`}>
            🧪 SDK Integration Test →
          </a>
        </div>
        <p className={styles.note}>
          <strong>🧪 SDK Integration Test:</strong> Simulates how customers will use the SDK
        </p>
      </div>
    </div>
  );
}
